import { createFileRoute } from '@tanstack/react-router';
import { Inbox } from '#features/notifications/components/inbox';

export const Route = createFileRoute('/_authed/inbox')({ component: Inbox });
